import React, { useEffect, useState } from 'react';
import FaqContent from '../faq/faq-content';
import ContactUsContent from '../contact-us/contact-us-content';
import CloseIcon from '@material-ui/icons/Close';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import Icon from '@material-ui/core/Icon';
import { useHistory } from 'react-router-dom';
import './support-page.scss';

const SupportPage = () => {
	const [activeTab, setActiveTab] = useState('faq');
	const [isDesktop, setIsDesktop] = useState(window.innerWidth > 980);
	const history = useHistory();

	useEffect(() => {
		const handleResize = () => {
			setIsDesktop(window.innerWidth > 980);
		};

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	return (
		<div className="support-page">
			<div className="wrapper">
				{/* Header */}
				<div className="header">
					<Icon
						className="close-page"
						onClick={() => history.push(isDesktop ? '/' : '/profile')}
						component={isDesktop ? CloseIcon : KeyboardArrowRightIcon}
					/>
					<h1 className="title">پشتیبانی</h1>
					<div className="spacer" />
				</div>

				{/* Tab Buttons */}
				<div className="tabs-container">
					<button
						onClick={() => setActiveTab('faq')}
						className={`tab-button ${activeTab === 'faq' ? 'active' : 'inactive'}`}
					>
						<div className={`icon-container ${activeTab === 'faq' ? 'active' : 'inactive'}`}>
							<svg viewBox="0 0 24 24" fill="currentColor">
								<path d="M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z" />
							</svg>
						</div>
						<span className="label">سوالات متداول</span>
					</button>

					<button
						onClick={() => setActiveTab('contact')}
						className={`tab-button ${activeTab === 'contact' ? 'active' : 'inactive'}`}
					>
						<div className={`icon-container ${activeTab === 'contact' ? 'active' : 'inactive'}`}>
							<svg viewBox="0 0 24 24" fill="currentColor">
								<path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
							</svg>
						</div>
						<span className="label">تماس با ما</span>
					</button>
				</div>

				{/* Content */}
				{activeTab === 'faq' && <FaqContent />}
				{activeTab === 'contact' && <ContactUsContent />}
			</div>
		</div>
	);
};

export default SupportPage;
